import Vue from 'vue';
import App from './App.vue';
import router from './router';
import CONFIG from './config';
import { GAtracker } from './services/ga.service';
import './directives/track-event.directive';
import VueSnackbar from 'vue-snack' ;
import 'vue-snack/dist/vue-snack.min.css';
import Vuelidate from 'vuelidate';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';

Vue.use(PerfectScrollbar);

Vue.use(Vuelidate);

Vue.use(VueSnackbar, {
  position: 'top',
  time: 3000
});

Vue.config.productionTip = false;

// Get Query Parameters from URL
const parse = function (val) {
  let result = false;
  let tmp = [];
  const query = location.search.substr(1).split('&');

  query.forEach(item => {
    tmp = item.split('=');
    if (tmp[0]===val) {
      result = decodeURIComponent(tmp[1]);
    }
  });
  return result;
};

// Override Test Date if found
CONFIG.settings.date = parse('date') ? parse('date') : CONFIG.settings.date;

console.log('Test Custom Destination with date, ex: ?date=09/24/2020');

window.vueApp = new Vue({
  router,
  render: h => h(App),
  mounted() {
    if (CONFIG.analytics.ga) {
      GAtracker.init(CONFIG.analytics.ga);
    }
  }
}).$mount('#app');
